import MiniProgramPage from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/subpackage/manager/task-process.vue'
wx.createPage(MiniProgramPage)